export default "__VITE_ASSET__hlOFEj$R__"